import { motion } from "framer-motion";
import { cn } from "~/lib/utils";

const ROW_DELAYS = [-1, -8, -4, -11, -6, -13, -3] as const;

type TextRowProps = {
    items: readonly string[];
    highlight: string;
    index: number;
    reduceMotion: boolean;
};

export const TextRow = ({ items, highlight, index, reduceMotion }: TextRowProps) => {
    const movesRight = index % 2 === 0;

    return (
        <motion.div
            animate={reduceMotion ? undefined : { x: movesRight ? [-10, 10, -10] : [10, -10, 10] }}
            transition={{
                duration: 14,
                ease: "easeInOut",
                repeat: Infinity,
                delay: ROW_DELAYS[index],
            }}
            className="flex min-w-max items-center justify-center gap-3.5 lg:gap-6 text-[16px] lg:text-[20px]"
        >
            {items.map((item, itemIndex) => (
                <span key={`${item}-${itemIndex}`} className="contents">
                    <span
                        className={cn(
                            "whitespace-nowrap",
                            item === highlight
                                ? "rounded-full border border-pureWhite/40 px-2.5 py-1 text-pureWhite/80"
                                : "text-pureWhite/35"
                        )}
                    >
                        {item}
                    </span>
                </span>
            ))}
        </motion.div>
    );
}
